/* Cozyees: keyboard + screen reader fixes for Qikify quantity breaks and Add to cart (TEST Oct 23 2026).
   Undo: delete this file and its script tag in layout/theme.liquid. */
(function () {
  'use strict';
  var TIER = '.qvl-volume-tier';
  var RADIO = 'input.qvl-volume-tier__radio__input';

  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function setAttr(el, name, val) { if (el && el.getAttribute(name) !== val) el.setAttribute(name, val); }

  function fixWidget(root) {
    var tiers = root.querySelectorAll(TIER);
    tiers.forEach(function (tier, i) {
      var radio = tier.querySelector(RADIO);
      if (!radio) return;
      /* Separate names so every deal option gets its own Tab stop. Arrow keys are handled below. */
      setAttr(radio, 'name', 'qvl-volume-tier-' + i);
      var title = txt(tier.querySelector('.qvl-volume-tier__title'));
      var badge = txt(tier.querySelector('.qvl-volume-tier__badge'));
      var price = txt(tier.querySelector('.qvl-volume-tier__price--offer-per-unit'));
      var was = txt(tier.querySelector('.qvl-volume-tier__price--origin'));
      var label = [title, badge, price, was ? 'was ' + was : ''].filter(Boolean).join(', ');
      if (label) setAttr(radio, 'aria-label', label);
      setAttr(radio, 'aria-setsize', String(tiers.length));
      setAttr(radio, 'aria-posinset', String(i + 1));
      tier.querySelectorAll('select.qvl-variant-opt__select').forEach(function (sel, j, all) {
        if (sel.hasAttribute('aria-label')) return;
        var name = (sel.id.match(/qvl-variant-opt-([^-]+)-/) || [])[1] || 'Option';
        sel.setAttribute('aria-label', all.length > 1 ? name + ' for item ' + (j + 1) + ' of ' + title : name + ' for ' + title);
      });
    });
    var body = root.querySelector('.qvl-offer-box__body');
    if (body) {
      setAttr(body, 'role', 'group');
      var heading = txt(root.querySelector('.qvl-title'));
      if (heading) setAttr(body, 'aria-label', heading);
    }
  }

  function scan() { document.querySelectorAll('.qvl-volume').forEach(fixWidget); }

  /* Keep each radio's checked state in sync with the deal the app shows as selected,
     so screen readers announce the right one. */
  function syncChecked() {
    document.querySelectorAll(TIER).forEach(function (tier) {
      var radio = tier.querySelector(RADIO);
      var sel = tier.classList.contains('qvl-volume-tier--selected');
      if (radio && radio.checked !== sel) radio.checked = sel;
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(TIER)) { setTimeout(syncChecked, 50); setTimeout(syncChecked, 300); }
  }, true);

  /* Arrow keys move between deal options, like a normal radio group. */
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches(RADIO)) return;
    var dir = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
    if (!dir) return;
    var box = t.closest('.qvl-offer-box__body') || t.closest('.qvl-volume');
    var radios = Array.prototype.slice.call(box.querySelectorAll(RADIO)).filter(function (r) { return !r.disabled; });
    var next = radios[(radios.indexOf(t) + dir + radios.length) % radios.length];
    if (!next || next === t) return;
    e.preventDefault();
    next.focus();
    next.click();
  }, true);

  /* Enter on a deal option selects it (same as Space or a click) and never submits the form. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (!t.matches || !t.matches(RADIO)) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.repeat || t.disabled) return;
    t.click();
  }, true);

  /* Enter/Space on Add to cart: Chrome/Edge ignore the re-click that Qikify BoosterKit does after a
     keyboard-triggered click, so nothing gets added. Trigger a normal click instead. */
  var ATC = 'form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"], button[form][type="submit"][name="add"]';
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var t = e.target;
    if (!t.matches || !t.matches(ATC) || t.disabled || t.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    if (e.repeat) return;
    setTimeout(function () { t.click(); }, 0);
  }, true);
  document.addEventListener('keyup', function (e) {
    if ((e.key === ' ' || e.key === 'Spacebar') && e.target.matches && e.target.matches(ATC)) e.preventDefault();
  }, true);

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
